import { useSelector } from "hooks";
import { useLocalStorage } from "usehooks-ts";

export const EXOTIC_MESSAGE_KEY_PREFIX = "exoticMessageDismissed:";

export const useExoticMessageDismissed = () => {
  const userId = useSelector((state) => state.auth?.userId) ?? "anonymous";
  const [dismissed, setDismissed] = useLocalStorage<boolean>(
    `${EXOTIC_MESSAGE_KEY_PREFIX}${userId}`,
    false,
  );

  return { dismissed, setDismissed };
};
